import { JoinTeamResponse } from 'pure-js/types/JoinTeamResponse'
import { SignedInQueryParams } from 'pure-js/types/QueryParamTypes'
import { Team } from 'pure-js/types/Team'
import { User } from 'pure-js/types/User'

export type SignedInState = {
  data: {
    teamName?: string
    team?: Team
    existingTeamMembers: User[]
    joinTeamResponse?: JoinTeamResponse
    displayName?: string
    phone?: string
    privacyNoticeAcknowledged?: boolean
  } & SignedInQueryParams
  step: SignedInSteps
}

export type SignedInViewProps = {
  isLoading: boolean
  signedInState: SignedInState
  enableCreateNewTeam?: boolean
  onPressContinue: (state: SignedInState) => Promise<unknown>
  onClickBack: () => unknown
  onClickLater: () => unknown
  onClickCrateTeam: () => unknown
}

export enum SignedInSteps {
  GO_TO_DASHBOARD = 'GO_TO_DASHBOARD',
  ONBOARDING = 'ONBOARDING',
  SIGN_UP_FORM = 'SIGN_UP_FORM'
}

export const DEFAULT_SIGNED_IN_STATE: SignedInState = {
  data: {
    existingTeamMembers: []
  },
  step: SignedInSteps.GO_TO_DASHBOARD
}
